<template>
  <div v-if="showCard">
    <sdui-card
      :class="cardClass"
      :title="$t(`${translation}card.title`)"
      :description="$t(`${translation}card.description`)"
      :button-text="hideAction ? '' : $t(`${translation}card.button`)"
      :passive-secondary-text="$t('hints.passive_secondary_text')"
      :hide-action="hideAction"
      :gradient="gradient"
      :button-cy-data="buttonCyData"
      @track-close="clyTracking.trackApp().interaction.toggleTutorial({ tutorial: section, location: 'primary', show: false })"
      @close="showCard = false"
      @action="clyTracking.trackApp().interaction.toggleTutorial({ tutorial: section, location: 'primary', show: true }); showInfoModal = true"
    >
      <template #action v-if="hideAction">
        <div />
      </template>
    </sdui-card>

    <SModal v-if="!hideAction"
            v-model="showInfoModal"
            :header-title="$t(`${translation}modal.title`)"
            :show-footer-gradient="false"
    >
      <info-modal v-if="showInfoModal"
                  :section="section"
                  @close="showInfoModal = false"
      />
    </SModal>
  </div>
</template>

<script>
import SduiCard from './SduiCard.vue'
import InfoModal from '../modals/InfoModal.vue'
import { User } from 'src/store/models/index.js'
import clyTracking from 'src/config/services/countlyTracking/clyTracking.js'

export default {
  name: 'SduiInfoCard',
  components: { InfoModal, SduiCard },
  props: {
    section: {
      type: String,
      default: '',
    },

    gradient: {
      type: String,
      default: 'teal',
    },

    cardClass: {
      type: String,
      default: 'teal',
    },

    hideAction: {
      type: Boolean,
      default: false,
    },

    buttonCyData: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    clyTracking,
    showInfoModal: false,
  }),

  computed: {
    translation() {
      return `cardinfo.sections.${this.section}.`
    },

    propertyName() {
      // example of target value - user.properties['users.hints.news.hidden']
      return `users.hints.${this.section}.hidden`
    },

    showCard: {
      get() {
        return !this.$me?.properties[this.propertyName]
      },

      set(val) {
        const data = {}
        data[this.propertyName] = !val
        User.updateProps(data)
      }
    }
  }
}
</script>
